<template>
  <div class="logo">
    <img src="../../assets/img/img-logo.svg" alt="Logo Siemens" />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.logo {
  position: absolute;
  top: 0;
  z-index: 15;
  margin: 18px;
}
</style>
